import {useQuery, useMutation} from '@tanstack/react-query';
import {api} from '@eksab/api';
import type {SpinWheelOffer} from '../types';

interface Response {
  data: SpinWheelOffer[];
}

export const useSpinWheelOffers = (gameCode: string) => {
  return useQuery(['spin-wheel-offers', gameCode], () =>
    api.get<Response>(`spin-wheel/${gameCode}/offers`).then((res) => res.data.data),
  );
};

export const useSpinWheelMutation = (gameCode: string) => {
  return useMutation(() =>
    api.post<{data: SpinWheelOffer}>(`spin-wheel/${gameCode}/spin`).then((res) => res.data.data),
  );
};
